import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Container,
  Typography,
  Stack,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  IconButton,
  Menu,
  MenuItem
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

// Import content components
import PrivacyContent from './footer.privacy';
import TermsContent from './footer.terms';

const Footer = () => {
  const { t } = useTranslation();
  const [openPrivacy, setOpenPrivacy] = useState(false);
  const [openTerms, setOpenTerms] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenPrivacy = () => setOpenPrivacy(true);
  const handleOpenTerms = () => setOpenTerms(true);
  const handleClose = () => {
    setOpenPrivacy(false);
    setOpenTerms(false);
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handlePrivacyClick = () => {
    handleClose();
    handleMenuClose();
    setOpenPrivacy(true);
  };

  const handleTermsClick = () => {
    handleClose();
    handleMenuClose();
    setOpenTerms(true);
  };

  return (
    <Box
      component="footer"
      sx={{
        color: 'gray',
        py: 3,
        px: 0,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Stack direction="row" justifyContent="flex-end" alignItems="center">
          <IconButton onClick={handleMenuClick} color="inherit">
            <MenuIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handlePrivacyClick}>{t('footer.privacy')}</MenuItem>
            <MenuItem onClick={handleTermsClick}>{t('footer.terms')}</MenuItem>
            <MenuItem disabled>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {t('footer.copy')}
              </Typography>
            </MenuItem>
          </Menu>
        </Stack>
      </Container>

      {/* Privacy Dialog */}
      <Dialog
        open={openPrivacy}
        onClose={handleClose}
        disableEscapeKeyDown
        disableBackdropClick
      >
        <DialogTitle>{t('footer.privacy')}</DialogTitle>
        <DialogContent>
          <PrivacyContent />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t('footer.close')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Terms Dialog */}
      <Dialog
        open={openTerms}
        onClose={handleClose}
        disableEscapeKeyDown
        disableBackdropClick
      >
        <DialogTitle>{t('footer.terms')}</DialogTitle>
        <DialogContent>
          <TermsContent />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t('footer.close')}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Footer;
